import {
  isGeneratedUpload,
  registerUploadPayload,
  subscribeUpload,
  subscribeUploadSessionClear,
} from "./upload-payloads";

export type UploadAnnouncement = {
  operationId: string;
  name: string;
  retry?: () => Promise<unknown>;
  cancellationBestEffort?: boolean;
};

export function announceUpload(announcement: UploadAnnouncement) {
  if (isGeneratedUpload(announcement.operationId)) return;
  if (listeners.size === 0) {
    const { operationId } = announcement;
    pending.get(operationId)?.unsubscribe();
    const entry: PendingAnnouncement = { announcement: { ...announcement }, unsubscribe: () => undefined };
    pending.set(operationId, entry);
    entry.unsubscribe = subscribeUpload(operationId, (snapshot) => {
      if (snapshot.state === "pending" || snapshot.state === "uploading") return;
      pending.delete(operationId);
      entry.unsubscribe();
      entry.announcement.retry = undefined;
    });
    if (!pending.has(operationId)) entry.unsubscribe();
    return;
  }
  listeners.forEach((listener) => listener(announcement));
}

export function registerVisibleUpload(file: File): string {
  const operationId = registerUploadPayload(file);
  announceUpload({ operationId, name: file.name, cancellationBestEffort: true });
  return operationId;
}

export function subscribeUploadAnnouncements(listener: (announcement: UploadAnnouncement) => void) {
  listeners.add(listener);
  const announcements = [...pending.values()];
  clearPending();
  announcements.forEach(({ announcement }) => listener(announcement));
  return () => {
    listeners.delete(listener);
  };
}

type PendingAnnouncement = {
  announcement: UploadAnnouncement;
  unsubscribe: () => void;
};
const pending = new Map<string, PendingAnnouncement>();
const listeners = new Set<(announcement: UploadAnnouncement) => void>();
window.addEventListener("pagehide", clearPending);
subscribeUploadSessionClear(clearPending);

function clearPending() {
  pending.forEach(({ unsubscribe }) => unsubscribe());
  pending.clear();
}
